var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 184,
    viewBox: "0 0 309 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "right_top_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 309,
    height: 184
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h309v184H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#right_top_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224 115c58.015 0 104.289-35.097 133.707-78.994C387.352-8.23 404-66.368 404-128c0-61.632-16.648-119.77-46.293-164.006C328.289-335.903 282.015-371 224-371s-104.289 35.097-133.707 78.994C60.648-247.77 44-189.632 44-128 44-66.368 60.648-8.23 90.293 36.006 119.711 79.903 165.985 115 224 115z",
    stroke: "#55B794",
    strokeOpacity: 0.2,
    strokeWidth: 104
  }))));
}

export default __webpack_public_path__ + "./fonts/right_top.d27caf2678132babae17419ec531406d.svg";
export { SvgRightTop as ReactComponent };